<template>
  <div class="home-page" id="home-page">
    <div class="head-common"></div>
    <!-- swiper -->
    <div class="swiper-box">
      <swiper :options="swiperOption">
        <swiper-slide>
          <router-link to="/dingxiang">
            <img
              class="banner-img"
              alt
              src="https://ytk-front.oss-cn-beijing.aliyuncs.com/hybrid/h5/yanda-h5/1banner.jpg"
            />
          </router-link>
        </swiper-slide>
        <swiper-slide>
          <router-link to="/xueyuan">
            <img
              class="banner-img"
              alt
              src="https://ytk-front.oss-cn-beijing.aliyuncs.com/hybrid/h5/yanda-h5/2024-02-20/yd17.jpg"
            />
          </router-link>
        </swiper-slide>
        <swiper-slide>
          <router-link to="/kaiying">
            <img
              class="banner-img"
              alt
              src="https://ytk-front.oss-cn-beijing.aliyuncs.com/hybrid/h5/yanda-h5/3banner.jpg"
            />
          </router-link>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
    <!-- nav -->
    <div class="nav-box">
      <div class="nav-wrap">
        <div class="nav-item" v-for="item in navList" :key="item.name">
          <router-link :to="item.hookUrl">
            <img class="nav-img" alt :src="item.url" />
            <h6 class="nav-name">{{ item.name }}</h6>
          </router-link>
        </div>
      </div>
    </div>
    <img :src="fouterImg" class="fouterImg" alt="图片" />
  </div>
</template>

<script>
// @ is an alias to /src
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";

export default {
  name: "home",
  data() {
    return {
      msg: "homepage",
      swiperOption: {
        pagination: {
          el: ".swiper-pagination"
        },
        autoplay: true
      },
      navList: [
        {
          name: "西医考研",
          url:
            "https://ytk-front.oss-cn-beijing.aliyuncs.com/hybrid/h5/yanda-h5/icon1.png",
          hookUrl: { name: "dingxiang" }
        },
        {
          name: "中医考研",
          url:
            "https://ytk-front.oss-cn-beijing.aliyuncs.com/hybrid/h5/yanda-h5/icon2.png",
          hookUrl: { name: "fourday" }
        },
        {
          name: "免费试学",
          url:
            "https://ytk-front.oss-cn-beijing.aliyuncs.com/hybrid/h5/yanda-h5/icon3.png",
          hookUrl: "/shuqi"
        },
        // {
        //   name: "端午试学",
        //   url: require("../assets/img/index_page/nav3.png"),
        //   hookUrl: "duanwu"
        // },
        // {
        //   name: "百天冲刺",
        //   url: require("../assets/img/index_page/nav3.png"),
        //   hookUrl: { name: "chongci" }
        // },
        // {
        //   name: "寒假试学营",
        //   url: require("../assets/img/index_page/nav3.png"),
        //   hookUrl: { name: "dongji" }
        // },
        {
          name: "全年/半年集训",
          url:
            "https://ytk-front.oss-cn-beijing.aliyuncs.com/hybrid/h5/yanda-h5/icon4.png",

          hookUrl: { name: "zhongyi" }
        },
        {
          name: "西综带背班",
          url:
            "https://ytk-front.oss-cn-beijing.aliyuncs.com/hybrid/h5/yanda-h5/icon5.png",
          hookUrl: { name: "mingshi" }
        },
        {
          name: "医学科研",
          url:
            "https://ytk-front.oss-cn-beijing.aliyuncs.com/hybrid/h5/yanda-h5/icon6.png",
          hookUrl: { name: "xueyuan" }
        },
        {
          name: "医学保研",
          url:
            "https://ytk-front.oss-cn-beijing.aliyuncs.com/hybrid/h5/yanda-h5/icon7.png",
          hookUrl: { name: "kaiying" }
        },
        {
          name: "医学申博",
          url:
            "https://ytk-front.oss-cn-beijing.aliyuncs.com/hybrid/h5/yanda-h5/icon8.png",
          hookUrl: { name: "jidi" }
        },
      ],
      conImgList: [
        { url: require("../assets/img/index_page/index_ps_01.jpg") },
        { url: require("../assets/img/index_page/index_ps_02.jpg") }
      ],
      fouterImg:
        "https://ytk-front.oss-cn-beijing.aliyuncs.com/hybrid/h5/yanda-h5/2024-02-20/index.jpg"
    };
  },
  components: {
    swiper,
    swiperSlide,
  },
};
</script>
<style lang="less" scoped>
.home-page {
  .swiper-box {
    .banner-img {
      display: block;
      width: 100%;
    }
  }
  .nav-box {
    .nav-wrap {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      .nav-item {
        width: 25%;
        padding-top: 20px;
        .nav-img {
          display: block;
          width: 60%;
          margin: 0 auto;
        }
        .nav-name {
          font-weight: normal;
          padding: 10px 0;
          font-size: 14px;
        }
      }
    }
  }
  .video-box {
    // background-color: #f1f1f1;
    padding: 16px;
    .video-box-inner {
      background-color: #fff;
      .video-title {
        font-size: 22px;
        font-weight: bold;
        padding: 20px 0;
      }
      .video-p {
        line-height: 1.8;
        text-align: left;
        span {
          font-weight: bold;
        }
      }
      .video-wrap {
        video {
          width: 100%;
          height: auto;
        }
      }
    }
  }
  .hook-btn {
    display: inline-block;
    background-color: #9335fd;
    color: #fff;
    padding: 0 20px;
    margin-top: 20px;
    margin-bottom: 5px;
    height: 30px;
    line-height: 30px;
    border-radius: 15px;
  }
  .con-imgs-box {
    .con-img {
      display: block;
      width: 100%;
      margin: 0;
      padding: 0;
      outline: none;
    }
  }
  .fouterImg {
    width: 100%;
    display: block;
    width: 100%;
    margin: 0;
    padding: 16px 0 0;
    outline: none;
  }
}
</style>
<style lang="less">
#home-page {
  .swiper-pagination-bullet-active {
    background: #f0bb2d;
  }
}
</style>
